import { EventSourcePolyfill } from "event-source-polyfill";
import Util from "../../utils/Helpers";

const BASE_URL = Util.isLocalhost()
  ? `http://localhost:3214/banner`
  : `${Util.getCurrentHost()}/auth/auth/banner`;

const SSE_CONFIG = {
  heartbeatTimeout: 30000,
  reconnectInterval: 3000,
  maxRetryAttempts: 3,
};

export const bannerService = {
  async fetchAllBanners() {
    try {
      const response = await fetch(`${BASE_URL}/banners`);
      if (!response.ok) {
        throw new Error(`Failed to fetch banners: ${response.statusText}`);
      }
      return response.json();
    } catch (error) {
      console.error("Banner fetch error:", error);
      throw error;
    }
  },

  setupSSEConnection(onMessage, onError) {
    let retryCount = 0;

    const source = new EventSourcePolyfill(`${BASE_URL}/sse-banner`, {
      heartbeatTimeout: SSE_CONFIG.heartbeatTimeout,
      reconnectInterval: SSE_CONFIG.reconnectInterval,
    });

    source.onopen = () => {
      retryCount = 0;
    };

    source.onerror = (error) => {
      retryCount++;

      if (retryCount >= SSE_CONFIG.maxRetryAttempts) {
        console.warn(
          `SSE connection failed after ${SSE_CONFIG.maxRetryAttempts} attempts`
        );
        source.close();
      }

      if (onError) onError(error);
    };

    return source;
  },
};
